import { useInterval } from '@mantine/hooks';
import { FC, useMemo, useState } from 'react';

import { useCalendarStore } from '@/stores/calendarStore.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface Props {
    timeslotHeight: number;
    containerHeight: number;
}

const TimeNowIndicator: FC<Props> = ({ timeslotHeight, containerHeight }) => {
    const [current_time, setCurrentTime] = useState<Date>(new Date());
    useInterval(
        () => setCurrentTime(new Date()),
        30000, // 30 seconds
        { autoInvoke: true }
    );

    // Get header height and timeline interval from store
    const header_height = useCalendarStore((state) => state.header_height);
    const timeline_interval = useCalendarStore((state) => state.timeline_interval);

    // Calculate the top position for the current time
    const top_position = useMemo(() => {
        const time = dayjs(current_time);
        const minutes_since_start = time.hour() * 60 + time.minute();
        const pixels_per_minute = timeslotHeight / timeline_interval;

        // Calculate base position
        const base_position = timeslotHeight + minutes_since_start * pixels_per_minute;

        // Adjust for the header height if it's larger than the default timeslot height
        const additional_offset = header_height && header_height > timeslotHeight ? header_height - timeslotHeight : 0;

        // Add the offset to the base position
        return ((base_position + additional_offset) / containerHeight) * 100;
    }, [current_time, timeslotHeight, containerHeight, header_height, timeline_interval]);

    return (
        <div
            className="pointer-events-none absolute left-0 right-0 z-[5] h-[1px] bg-red-500"
            style={{ top: `${top_position}%` }}
        />
    );
};

export default TimeNowIndicator;
